import Cookies from "universal-cookie";

export const useAuth = () => {
  const cookies = new Cookies();
  const loginStatus = cookies?.get("loginStatus");
  const authToken = cookies?.get("authToken");
  let isSignedin = Boolean(loginStatus ?? "");
  let userInfo = loginStatus?.data;
  return { isSignedin, userInfo, authToken };
};
